module.exports = __webpack_public_path__ + "static/key-horace-2d80c44408264e7d98ee36e9d4fa7b67.webp";